export default __webpack_public_path__ + "static/media/newsReport.6c6bdf3a.svg";